<tacho-page-header></tacho-page-header>
<div class="tacho-page">
	<div class="tacho-page-content-titles">
		<h1>{{ cardService.title$ | async }}</h1>
		<small>{{ cardService.subtitle$ | async }}</small>
	</div>
	<tacho-data-loader imageSrc="assets/images/page-body/remove_driver_card.svg"
					   [loading]="false"></tacho-data-loader>
</div>
<tacho-page-footer></tacho-page-footer>